// extracted by mini-css-extract-plugin
export var header = "_xa-1";
export var maskBottom = "_xa-6";
export var maskMiddle = "_xa-7";
export var maskTop = "_xa-5";
export var root = "_xa-0";
export var scrollDownButton = "_xa-3";
export var scrollDownButtonHidden = "_xa-4";
export var viewport = "_xa-2";